// extracted by mini-css-extract-plugin
export default {"faq":"PAI4d","faqTitle":"rcnDU","skeleton-progress":"MqkvD"};